import LibraryElementEnum from 'client/enums/LibraryElementEnum'
import { createDefaultEntityStructure } from 'client/utils/createStructureUtils'
import { createWebsiteButtonFromLibrary } from 'src/editor/pages/website/create-website-button-from-library'
import {
  CommonLibraryElementsStructuresCreator,
  CreatorArgs,
} from 'src/editor/shared/entities/common-library-elements-structures-creator'
import { createWebsiteLanguageSwitcher } from 'src/editor/shared/entities/website-language-switcher/create-website-language-switcher'
import { createWebsiteButton } from 'src/shared/entities/website-button/create-website-button'
import { WebsiteLibraryElementsCreator } from './website-library-elements-creator'

export class WebsiteLibraryElementsStructuresCreator extends CommonLibraryElementsStructuresCreator {
  constructor() {
    super(WebsiteLibraryElementsCreator)
  }

  protected [LibraryElementEnum.LibraryWebsiteButton](args: CreatorArgs) {
    return createWebsiteButtonFromLibrary({
      createButton: createWebsiteButton,
      ...args,
    })
  }

  protected [LibraryElementEnum.LibraryWebsiteLanguageSwitcher](
    args: CreatorArgs,
  ) {
    return createDefaultEntityStructure({
      createEntity: createWebsiteLanguageSwitcher,
      ...args,
    })
  }
  // ------------------------------
  // NOTE: website entity structure creators
  // ------------------------------
  // protected [LibraryElementEnum.LibraryWebsiteForm](args: CreatorArgs) {
  //   return createDefaultEntityStructure(
  //     {
  //       createEntity: this.createElement.createWebsiteForm,
  //       ...args
  //     }
  //   )
  // }
  // ------------------------------
}
